import { BankAccountType } from '@zorro/clients';
import * as yup from 'yup';

export const paymentAccountDetailsSchema = yup.object({
  bankAccountName: yup.string().required('Bank account name is required'),
  bankAccountNumber: yup
    .string()
    .required('Bank account number is required')
    .matches(/^\d+$/u, 'Bank account number must contain only digits'),
  routingNumber: yup
    .string()
    .required('Routing number is required')
    .matches(/^\d{9}$/u, 'Routing number must be exactly 9 digits'),
  bankAccountType: yup
    .mixed<BankAccountType>()
    .oneOf(
      Object.values(BankAccountType),
      'Account type must be either Checking or Savings'
    )
    .required('Account type is required'),
  kybConfirmed: yup
    .boolean()
    .required('KYB confirmation is required')
    .oneOf([true], 'You must confirm KYB verification has been completed'),
});

export type PaymentAccountDetailsFormFields = yup.InferType<
  typeof paymentAccountDetailsSchema
>;
